import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateWorkflowNodeMutationVariables = Types.Exact<{
  input: Types.CreateWorkflowNodeInput;
}>;

export type CreateWorkflowNodeMutation = {
  __typename?: 'Mutation';
  createWorkflowNode:
    | {
        __typename?: 'ActionNode';
        id: any;
        position: any;
        styleData: any;
        createdAt: any;
        updatedAt: any;
      }
    | { __typename?: 'DelayNode' }
    | { __typename?: 'EnricherNode' }
    | {
        __typename?: 'FilterNode';
        id: any;
        position: any;
        styleData: any;
        createdAt: any;
        updatedAt: any;
      }
    | { __typename?: 'MergeNode' }
    | {
        __typename?: 'SignalNode';
        id: any;
        position: any;
        styleData: any;
        createdAt: any;
        updatedAt: any;
      }
    | { __typename?: 'SubWorkflowNode' }
    | {
        __typename?: 'TransformerNode';
        id: any;
        position: any;
        styleData: any;
        createdAt: any;
        updatedAt: any;
      };
};

export const CreateWorkflowNodeDocument = gql`
  mutation CreateWorkflowNode($input: CreateWorkflowNodeInput!) {
    createWorkflowNode(input: $input) {
      ... on SignalNode {
        id
        position
        styleData
        createdAt
        updatedAt
      }
      ... on ActionNode {
        id
        position
        styleData
        createdAt
        updatedAt
      }
      ... on TransformerNode {
        id
        position
        styleData
        createdAt
        updatedAt
      }
      ... on FilterNode {
        id
        position
        styleData
        createdAt
        updatedAt
      }
    }
  }
`;
export type CreateWorkflowNodeMutationFn = Apollo.MutationFunction<
  CreateWorkflowNodeMutation,
  CreateWorkflowNodeMutationVariables
>;

/**
 * __useCreateWorkflowNodeMutation__
 *
 * To run a mutation, you first call `useCreateWorkflowNodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowNodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowNodeMutation, { data, loading, error }] = useCreateWorkflowNodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkflowNodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateWorkflowNodeMutation,
    CreateWorkflowNodeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateWorkflowNodeMutation,
    CreateWorkflowNodeMutationVariables
  >(CreateWorkflowNodeDocument, options);
}
export type CreateWorkflowNodeMutationHookResult = ReturnType<
  typeof useCreateWorkflowNodeMutation
>;
export type CreateWorkflowNodeMutationResult =
  Apollo.MutationResult<CreateWorkflowNodeMutation>;
export type CreateWorkflowNodeMutationOptions = Apollo.BaseMutationOptions<
  CreateWorkflowNodeMutation,
  CreateWorkflowNodeMutationVariables
>;
